import React, { useState } from "react";
import "./ChangeNumber.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import Verification from "../../Components/Verification/Verification";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import Alert from "../../Components/Alert/Alert";
import { useCookies } from "react-cookie";
import { useBaseUrl } from "../../ApiContext";

export default function ChangeNumber() {
  const { userToken, setUserToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const [loginPhoneNumber, setLoginPhoneNumber] = useState("");
  const [sendVerificationCode, setSendVerificationCode] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [cookie, setCookie] = useCookies(["token"]);
  const [showAlert, setShowAlert] = useState(false);
  const [verificationCode, setVerificationCode] = useState(null);
  const [alertText, setAlertText] = useState("");

  const handlePhoneNumberChange = (event) => {
    setLoginPhoneNumber(event.target.value);
  };

  const handlePhoneNumberKeyUp = (event) => {
    if (event.which !== 8) {
      if (loginPhoneNumber.length == 2 || loginPhoneNumber.length == 6) {
        setLoginPhoneNumber((prevPhoneNumber) => prevPhoneNumber + " ");
      }
    }
  };

  const recieveCodeHandler = async () => {
    setSendVerificationCode(true);

    if (loginPhoneNumber.length === 11) {
      try {
        const response = await Axios.post(
          `${baseUrl}/change/check_number`,
          {
            username: `09${loginPhoneNumber.replace(/\s/g, "")}`,
            first_name: "",
            last_name: "",
            latin_name: "",
          },
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
      } catch (error) {
        if (error.response && error.response.status === 409) {
          setShowAlert(true);
          setAlertText("کاربر با شماره همراه وارد شده از قبل وجود دارد");
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
        } else if (error.response && error.response.status === 429) {
          setShowAlert(true);
          setAlertText("تعداد درخواست ها بیش از حد مجاز است");
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
        } else {
          console.log("Error during checking number", error);
        }
      }
    }
  };

  const isCompleteHandler = (code) => {
    setIsComplete(true);
    setVerificationCode(code);
  };

  const sendVerificationRequest = async (code) => {
    try {
      const response = await Axios.post(`${baseUrl}/verify_number`, {
        username: `09${loginPhoneNumber.replace(/\s/g, "")}`,
        authentication_code: code,
      });
      setUserToken(response.data.token);
      const threeMonthsInMilliseconds = 90 * 24 * 60 * 60 * 1000;
      setCookie("token", response.data.token, {
        path: "/",
        maxAge: threeMonthsInMilliseconds / 1000,
      });
      navigate("/home");
      setShowAlert(true);
      setAlertText("تغییر شماره همراه با موفقیت انجام شد");
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      localStorage.setItem(
        "userPhoneNumber",
        `09${loginPhoneNumber.replace(/\s/g, "")}`
      );
    } catch (error) {
      if (error.response && error.response.status === 406) {
        setShowAlert(true);
        setAlertText("خطا در برقراری ارتباط");
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      } else {
        console.error("Verification error:", error);
      }
    }
  };

  const handleChangeNumberSubmit = () => {
    if (isComplete) {
      sendVerificationRequest(verificationCode);
    } else {
      setShowAlert(true);
      setAlertText("لطفا کد فعالسازی ارسال شده را وارد نمایید");

      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="changeNumberWrapper pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">تغییر شماره همراه</div>
          <div className="changeNumberContent centeredFlex responsiveWidth">
            <div className="changeNumberContentTop">
              <PhoneInput
                sendVerificationCode={sendVerificationCode}
                loginPhoneNumber={loginPhoneNumber}
                onNumberChange={(event) => handlePhoneNumberChange(event)}
                onNumberKeyUp={(event) => handlePhoneNumberKeyUp(event)}
              />
              <div className="changeNumberCode">
                <p>کد 5 رقمی ارسال شده به شماره‌تان را وارد کنید.</p>
                <Verification
                  isComplete={isComplete}
                  onComplete={(code) => isCompleteHandler(code)}
                />
              </div>
            </div>
            <div className="changeNumberBtns centeredFlex">
              <button
                className="changeNumberBtn recieveCode"
                style={
                  loginPhoneNumber.length === 11
                    ? { color: "#FFF" }
                    : { color: "#060a4d" }
                }
                onClick={recieveCodeHandler}
              >
                دریافت کد
              </button>
              <button
                onClick={handleChangeNumberSubmit}
                className="changeNumberBtn confirm"
                style={
                  loginPhoneNumber.length === 11
                    ? { color: "#FFF" }
                    : { color: "#11580b" }
                }
              >
                تایید
              </button>
            </div>
            <Alert showAlert={showAlert} alertText={alertText} />
          </div>
        </div>
      </div>
    </div>
  );
}
